import React, { createContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { themes } from '../containers/Fireboard/fireboardTheme';
import { getBackendTheme } from './fireboardUtil';

export const ThemeContext = createContext();

export const FireboardThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => getBackendTheme());

  const themeProperties = useSelector(state => state.theme.themeProperties);
  useEffect(() => {
    let newTheme = 'light';
    try {
      newTheme = getBackendTheme(themeProperties);
    } catch (e) {
      newTheme = 'light';
    }
    setTheme(newTheme);
  }, [themeProperties]);

  useEffect(() => {
    const themeVariables = themes[theme];
    if (themeVariables) {
      Object.entries(themeVariables).forEach(([key, value]) => {
        document.documentElement.style.setProperty(key, value);
      });
    }
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
